module.exports = __webpack_public_path__ + "img/logo.7768f898.png";